<template>
	<div class="date-inputs">
		<div>
			<div class="date-inputs--day">
				<b-input v-model="day" type="text" placeholder="TT" @input="dayChanged"/>
			</div>
			<div class="date-inputs--point">.</div>
			<div class="date-inputs--month">
				<b-input v-model="month" type="text" placeholder="MM" ref="month" @input="monthChanged"/>
			</div>
			<div class="date-inputs--point">.</div>
			<div class="date-inputs--year">
				<b-input v-model="year" type="text" placeholder="JJJJ" ref="year" @input="yearChanged"/>
			</div>
		</div>
		<div v-if="showError" class="error">{{ error }}</div>
	</div>
</template>

<script>
import {isDefined} from "@/helper/Value";
import {isEmptyOrNull} from "@/helper/String";
import {DateTime} from "luxon";
import _ from "lodash";
import {isPositiveInteger} from "@/helper/Number";

export default {

	props: {
		value: {
			type: Object,
			required: false,
		},
		showIncompleteError: {
			type: Boolean,
			required: false,
			default: true
		}
	},

	data ()
	{
		let day = '';
		let month = '';

		if (this.value?.day)
		{
			day = _.padStart(this.value.day, 2, '0');
		}

		if (this.value?.month)
		{
			month = _.padStart(this.value.month, 2, '0');
		}

		return {
			day,
			month,
			year: this.value?.year
				? this.value.year.toString()
				: '',
		};
	},

	computed: {
		isComplete ()
		{
			return !isEmptyOrNull(this.day)
				&& !isEmptyOrNull(this.month)
				&& !isEmptyOrNull(this.year);
		},
		showError ()
		{
			if (!this.showIncompleteError && !this.isComplete)
			{
				return false;
			}

			return !isEmptyOrNull(this.day)
				|| !isEmptyOrNull(this.month)
				|| !isEmptyOrNull(this.year);
		},
		error ()
		{
			if (
				isEmptyOrNull(this.day)
				|| isEmptyOrNull(this.month)
				|| isEmptyOrNull(this.year)
			)
			{
				return 'Eingaben unvollständig';
			}

			if (
				!isPositiveInteger(this.day)
				|| !isPositiveInteger(this.month)
				|| !isPositiveInteger(this.year)
			)
			{
				return 'Ungültiges Datum';
			}

			const year = parseInt(this.year);

			let dateTime;

			try
			{
				dateTime = DateTime.fromObject({
					day: parseInt(this.day),
					month: parseInt(this.month),
					year,
				});
			}
			catch (e)
			{
				return 'Ungültiges Datum';
			}

			const now = DateTime.now();

			if (dateTime.invalid || year < 1900 || dateTime > now)
			{
				return 'Ungültiges Datum';
			}

			return undefined;
		},
		valid ()
		{
			return !isDefined(this.error);
		}
	},

	methods: {
		dayChanged ()
		{
			if (this.day.length === 2)
			{
				this.$refs.month.focus();
			}

			this.emitChangeEvent();
		},
		monthChanged ()
		{
			if (this.month.length === 2)
			{
				this.$refs.year.focus();
			}

			this.emitChangeEvent();
		},
		yearChanged ()
		{
			this.emitChangeEvent();
		},
		emitChangeEvent ()
		{
			if (!this.valid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				day: parseInt(this.day),
				month: parseInt(this.month),
				year: parseInt(this.year),
			});
		}
	}
}
</script>
